export const initialState = {};
export function computeStdoutId(scenario, workspace = "default", program, mode) {
    return `${scenario}_${workspace}_${program}_${mode}`;
}
//# sourceMappingURL=common.js.map